module.exports = __webpack_public_path__ + "static/theatre_chairs_wide-1e2e7a3db1bb4b2603dfe36a85332bf8.jpg";